export default "__VITE_ASSET__BCCsg$Oa__"